import { useRef } from "react";
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import SinglePage from "../SinglePage/SinglePage";
import { Container } from "./styles";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import Topic from "../../base/Topic/Topic";
import TopicIntro from "../../base/Topic/TopicIntro";
import { Link } from "react-router-dom";

export default function ErrorPage() {
  const topicIntroRef = useRef<HTMLDivElement>(null);

  const scrollToTopicIntro = () => {
      if (topicIntroRef.current) {
          smoothScrollTo(topicIntroRef.current, 2000);
      }
  };

  return (<SinglePage
    title='404'
    heroBanner={
        <HeroBanner 
        imageSource = {require('../../../assets/images/History/MysticBoar.png')}
        headline="FEHLER 404."
        text="Die gesuchte Seite konnte leider nicht gefunden werden." 
        onNextSection={scrollToTopicIntro}
        />
    }
    topic={
        <div ref={topicIntroRef}>
            <TopicIntro
            headline="FEHLER 404."
            introductionText={<span>Es tut uns leid. Die gesuchte Seite konnte leider nicht gefunden werden. Nutze die Zurück-Taste deines Browsers oder klicke <Link to='/'>hier</Link> um zur Startseite zu gelangen.</span>}
            />
        </div>
    }
    content={
        <>
            <Container>
            </Container>
        </>
    }
    >
</SinglePage>
);
}